<template>
    <div>
        <div class="search-products">
            <div class="product"
                v-for="(product) in products"
                v-if="product.images && product.images.length > 0"
                :key="product.product_id"
                @click="handleOnClick(product)"
            >
                <div class="image">
                    <img :alt="product.title" :src="product.images[0].value || ''" />

                    <save-product
                        :product="product" />
                </div>
                <span class="brand">{{ product.brand }}</span>
                <span class="title">{{ product.title }}</span>
            </div>
        </div>
        <infinite-loading
            @infinite="performSearch"
            ref="infiniteLoading"
            spinner="waveDots"
            force-use-infinite-wrapper
        >
            <div slot="no-more" class="no-more" v-show="false"></div>
            <div slot="no-results" class="no-results" v-show="false"></div>
        </infinite-loading>
        <div class="no-results" v-show="!products.length">No search results found</div>
    </div>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';
    import InfiniteLoading from 'vue-infinite-loading';
    import SaveProduct from '../products/save-product.vue'

    export default {
        props: {
            products: Array,
            handleOnClick: Function,
            performSearch: Function,
            setSortOption: Function
        },
        components: {
            InfiniteLoading,
            SaveProduct
        },
        mixins: [Mixins],
        data() {
            return {
            };
        },
        computed: {
        },
        methods: {
        },
        mounted() {
        },
    }
</script>
